"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const faCaretRight_1 = require("@fortawesome/pro-solid-svg-icons/faCaretRight");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const material_1 = require("@mui/material");

const react_1 = __importStar(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip/SskyTooltip"));

const PREFIX = 'SskySubMenuItem';
const classes = {
  item: `${PREFIX}-item`
};
const Root = (0, material_1.styled)('div')(() => ({
  [`& .${classes.item}`]: {
    height: 48,
    display: "flex",
    justifyContent: "space-between"
  }
}));

const SskySubMenuItem = props => {
  const [anchorElement, setAnchorElement] = (0, react_1.useState)(null);

  const handleItemClick = event => {
    setAnchorElement(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setAnchorElement(null);
    props.onClose();
  };

  const renderItems = () => {
    return props.items.map(item => {
      if (item.tooltip) {
        return react_1.default.createElement(SskyTooltip_1.default, {
          title: item.tooltip,
          enterDelay: 300,
          placement: "right",
          left: props.tooltipLeft,
          key: item.id
        }, react_1.default.createElement("div", null, react_1.default.createElement(material_1.MenuItem, {
          disabled: item.disabled,
          classes: {
            root: classes.item
          },
          onClick: item.onClick,
          divider: item.divider,
          "data-testid": item.dataTestId || `testId-${item.content}`
        }, item.content)));
      }

      return react_1.default.createElement(material_1.MenuItem, {
        id: item.id,
        key: item.id,
        disabled: item.disabled,
        classes: {
          root: classes.item
        },
        onClick: item.onClick,
        divider: item.divider,
        "data-testid": item.dataTestId || `testId-${item.content}`
      }, item.content);
    });
  };

  return react_1.default.createElement(Root, null, react_1.default.createElement(material_1.MenuItem, {
    onClick: handleItemClick,
    id: props.id,
    "data-testid": props.dataTestId ? `${props.dataTestId}-menuItem` : `testId-${props.content}-menuItem`,
    classes: {
      root: classes.item
    }
  }, props.content, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: faCaretRight_1.faCaretRight,
    className: "sub-menu-icon"
  })), react_1.default.createElement(material_1.Menu, {
    anchorEl: anchorElement,
    open: Boolean(anchorElement),
    onClose: handleSubMenuClose,
    "data-testid": props.dataTestId ? `${props.dataTestId}-menu` : `testId-${props.content}-menu`,
    PaperProps: {
      style: {
        maxHeight: props.maxHeight,
        minWidth: 100
      }
    },
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, renderItems()));
};

exports.default = react_1.default.memo(SskySubMenuItem);